export const profiles = [
  { id: 1, keyword: 'administrativo', label: 'configuration.roles.form.admin.label' },
  { id: 2, keyword: 'docente', label: 'configuration.roles.form.collaborator.label' },
  { id: 3, keyword: 'estudiante', label: 'configuration.roles.form.student.label' },
];
